import { IonAlert, IonButton, IonCol, IonGrid, IonIcon, IonInput, IonItem, IonList, IonRow, IonSpinner } from '@ionic/react';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { getConfig } from '../../appConfig';
import Basket from '../../lib/basket';
import { withTranslation } from '../../lib/translate';
import { deepCopy, forwardTo, isDefined, isEmptyObject, makeKey, weekdays } from '../../lib/utils';
import { getIkentooMenusForLocation, removeVoucher, setCommonProp, setModal } from '../../store/actions';
import { MediumText, NormalText, SmallText, Spacer, StrongText, Subtitle, Title } from '../common';
import { closeOutline } from 'ionicons/icons';
import Incrementer from '../incrementer';
import Modal from '../modal';
import './index.css';
import moment from 'moment';
import { GET_TAX } from '../../store/constants';
import { ReactComponent as TrashIcon } from '../../assets/images/trash.svg';

class OrderContent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			serviceChargeModalOpen: false,
			showCharge: false,
			serviceChargeAmount: null,
			serviceChargeBoxModalOpen: false,
			removeItem: {},
			showRemoveItemAlert: false,
			removeItemAlertFunction: () => null,
			removeServiceChargeModal: false
		};
	}

	handleServiceChargeModal = (flag) => {
		this.setState({ serviceChargeModalOpen: flag });
	};

	drawSubItems = (basketItem = {} /*, basketItemIndex*/) => {
		const { selectedChoices } = basketItem;
		const basketInstance = this.props.basketInstance || Basket;
		const { profile } = this.props;
		if (selectedChoices && selectedChoices.length > 0) {
			return selectedChoices.map((choiceGroup, choiceGroupIndex) => {
				return (choiceGroup || []).map((choice, choiceIndex) => {
					const { sku } = choice;
					return (
						<IonRow className="sub-item" key={makeKey(choiceGroupIndex, choiceIndex, sku)} /*onClick={ () => this.handleOrderItemClick(basketItem, basketItemIndex) }*/>
							<IonCol size="50px"></IonCol>
							<IonCol className="paddLR grow">
								{choice.quantity} x {Basket.getProductName(choice, profile)}
							</IonCol>
							<IonCol className="righted paddLR self-aligned">
								{basketInstance.calculateSubItemPrice(choice, choice.quantity) !== 0 ? basketInstance._calculateSubItemPrice(choice, choice.quantity) : null}
							</IonCol>
						</IonRow>
					);
				});
			});
		}
		return null;
	};
	drawSubItemsText = (basketItem = {} /*, basketItemIndex*/) => {
		const { selectedChoices } = basketItem;
		const basketInstance = this.props.basketInstance || Basket;
		const { profile } = this.props;
		if (selectedChoices && selectedChoices.length > 0) {
			return selectedChoices.map((choiceGroup, choiceGroupIndex) => {
				return (choiceGroup || []).map((choice, choiceIndex) => {
					const { sku } = choice;
					return (
						<div className="sub-item modifier-item" key={makeKey(choiceGroupIndex, choiceIndex, sku)} /*onClick={ () => this.handleOrderItemClick(basketItem, basketItemIndex) }*/>
							<NormalText className="paddLR grow label-color">
								{choice.quantity} x {Basket.getProductName(choice, profile)}
							</NormalText>
							<NormalText className="righted paddLR self-aligned label-color">
								{basketInstance.calculateSubItemPrice(choice, choice.quantity) !== 0 ? basketInstance._calculateSubItemPrice(choice, choice.quantity) : null}
							</NormalText>
						</div>
					);
				});
			});
		}
		return null;
	};
	selectServicePercentage(serviceCharge) {
		const basketInstance = this.props.basketInstance || Basket;
		const serviceChargeApplied = basketInstance.getServicePercentage();
		return serviceCharge === serviceChargeApplied;
	}
	customServiceChargeSelected = () => {
		return !Basket.service_percentage && Basket.service_charge > 0
	}
	drawServiceChargeBox = (__, service_charge, basketInstance) => {
		const serviceChargeBoxHidden = false
		return (
			<IonList className="service-charge-box-wrapper box-wrapper centered">
				<div className='service-charge-title' style={{paddingBottom:0}}>
					{!serviceChargeBoxHidden && <MediumText style={{textAlign:'left'}}>{__('Optional service charge?')}</MediumText>}
					<MediumText style={{textAlign:'right'}}>{basketInstance.getServiceChargeValue() > 0 ? basketInstance.getFormatedServiceChargeValue() : basketInstance.getServiceCharge(true)}</MediumText>
				</div>
				<div className="service-charge-values">
					{service_charge.map((item) => {
						return (
							<IonButton
								className={this.selectServicePercentage(item) && 'is-active'}
								key={item + 'service_charge'}
								expand="block"
								color="primary"
								onClick={(e) => {
									e.stopPropagation();
									document.querySelectorAll('.service-charge-values ion-button').forEach((el) => el.classList.remove('is-active'));
									e.target.classList.add('is-active');
									this.selectServicePercentage(item) ? basketInstance.setServicePercentage(0) : basketInstance.setServicePercentage(item)
								}}
							>
								{item === 0 ? <NormalText>{__('None')} </NormalText> : <NormalText>{item}% </NormalText>}
							</IonButton>
						);
					})}
					<IonButton
						className={this.customServiceChargeSelected() && 'is-active'}
						expand="block"
						color="primary"
						onClick={() => this.setState({ serviceChargeModalOpen: true, serviceChargeBoxModalOpen: false })}>
						<NormalText>{__("Custom")}</NormalText>
					</IonButton>
				</div>



			</IonList>
		);
	};
	setCustomServiceCharge = (value) => {
		if (value >= 0) {
			this.setState({ serviceChargeAmount: value, customAmountErrorVisible: false });
		} else {
			this.setState({ customAmountErrorVisible: true, serviceChargeAmount: 0 });
		}
	};
	getOrderStatusColor = (val) => {
		const status = val.toUpperCase();
		let color = '';
		if (status === 'PREPARING' || status === 'ONWAY') {
			color = 'warning';
		} else if (status === 'COLLECTED' || status === 'READY' || status === 'DELIVERED') {
			color = 'success';
		} else if (status === 'FAILED' || status === 'PAYMENT FAILED') {
			color = 'danger';
		} else {
			color = 'gray';
		}
		return color;
	};
	selectMultiVenueRestaurant = (restaurant) => {
		Basket.setRestaurant(restaurant);
		if (Basket.order_type == 'collection') {
			const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(restaurant.business_location_id, {
						pickTime,
						json_time_selector: restaurant ? restaurant.kiosk_json_time_selector : [],
					}),
				);
			});
		} else if (Basket.order_type == 'table') {
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(restaurant.business_location_id, {
						pickTime: 'asap',
						json_time_selector: restaurant ? restaurant.kiosk_table_json_time_selector : [],
					}),
				);
			});
		} else if (Basket.order_type == 'pick-up-at-counter') {
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(
						restaurant.business_location_id,
						{
							pickTime: 'asap',
							json_time_selector: restaurant ? restaurant.pick_up_at_counter_json_time_selector : [],
						},
						false,
					),
				);
			});
		} else if (Basket.order_type == 'browse-menu') {
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(
						restaurant.business_location_id,
						{
							pickTime: 'asap',
							json_time_selector: restaurant ? restaurant.browse_menu_json_time_selector : [],
						},
						restaurant.browse_menu_json_time_selector.length === 1 ? false : true,
					),
				);
			});
		} else if (Basket.order_type == 'charter-delivery') {
			const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(restaurant.business_location_id, {
						pickTime,
						json_time_selector: restaurant ? restaurant.charter_delivery_times_json : [],
					}),
				);
			});
		} else if (Basket.order_type == 'scheduled-delivery') {
			const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(restaurant.business_location_id, {
						pickTime,
						json_time_selector: [
							{
								menuId: restaurant?.active_menus.scheduled_delivery?.menu_id,
								availability: Object.keys(restaurant?.active_menus.scheduled_delivery?.slots).map((slot) => {
									if (restaurant?.active_menus.scheduled_delivery?.slots[slot].start_time) {
										return {
											d: weekdays[slot],
											start: restaurant?.active_menus.scheduled_delivery?.slots[slot].start_time,
											end: restaurant?.active_menus.scheduled_delivery?.slots[slot].end_time,
										};
									}
								}),
							},
						],
					}),
				);
			});
		} else if (Basket.order_type == 'scheduled-collection') {
			const pickTime = moment.unix(Basket.collection_time).tz(getConfig().timezone).format('HH:mm');
			this.setState({ selectRestaurantsModalOpen: false }, () => {
				this.props.dispatch(
					getIkentooMenusForLocation(restaurant.business_location_id, {
						pickTime,
						json_time_selector: [
							{
								menuId: restaurant?.active_menus.scheduled_collection?.menu_id,
								availability: Object.keys(restaurant?.active_menus.scheduled_collection?.slots).map((slot) => {
									if (restaurant?.active_menus.scheduled_collection?.slots[slot].start_time) {
										return {
											d: weekdays[slot],
											start: restaurant?.active_menus.scheduled_collection?.slots[slot].start_time,
											end: restaurant?.active_menus.scheduled_collection?.slots[slot].end_time,
										};
									}
								}),
							},
						],
					}),
				);
			});
		}
	};
	finaliseTableOrder = () => {
		this.props.dispatch(setCommonProp('serviceChargeBoxAlertOpen', false));

		let data = Basket.has_multi_basket
			? deepCopy(Basket.multi_basket_items)
			: [
				{
					restaurant: { business_location_id: Basket.getRestaurant()?.business_location_id },
					items: Basket.items,
				},
			];
		const additionalData = Basket.getAdditionalTaxData();
		if (additionalData) {
			data.push(additionalData);
		}
		this.props.dispatch({ type: GET_TAX, data, includeAll: true });
	};
	calculateOrderPoints = () => {
		let calculatedPoints = Math.floor(Basket.getTotal() * getConfig().api_config.points_value_percentage);
		return calculatedPoints.toFixed(0);
	};
	render() {
		const { handleOrderItemClick, __, history, profile, showAddItems, dispatch, isRemoveVoucherModalOpen, taxContentLoading, showOnlyItems, showOnlyAmount } = this.props;
		const { showRemoveItemAlert, removeItemAlertFunction } = this.state;
		const basketInstance = this.props.basketInstance || Basket;
		const type = this.props.type || 'order';
		const orderType = basketInstance.getOrderType();
		const appliedPoints = basketInstance.getAppliedPoints();
		const deliveryPrice = basketInstance.getDeliveryPrice();
		const deliveryPriceUnformated = basketInstance._getDeliveryPrice();
		const { serviceChargeModalOpen, removeItem } = this.state;
		const appliedVoucher = basketInstance.getAppliedVoucher();
		const appliedGiftCards = basketInstance.getAppliedGiftCards();
		const serviceChargeBoxHidden = false
		let location = history && history.location && history.location.pathname === '/history-details' ? true : false;
		let service_charge_original;
		let service_charge = [];
		if (!basketInstance.service_charge_value && basketInstance.service_charge_value !== 0 && getConfig().general.service_charge_modules?.includes(Basket.order_type)) {
			if (basketInstance.getRestaurantServiceCharge()) {
				service_charge_original = basketInstance.getRestaurantServiceCharge();
			} else {
				service_charge_original =
					typeof getConfig().general.defaultServiceCharge == 'string' ? JSON.stringify(getConfig().general.defaultServiceCharge) : getConfig().general.defaultServiceCharge;
			}
			service_charge = service_charge_original.map((el) => Number((el * 100).toFixed(2)));
		}
		const isAlreadyCreatedOrder = type === 'orderHistory';

		return (
			<>
				<>
					<div className='box-with-gradient' style={{ flex: 1 }}>
						{basketInstance.has_multi_basket && !basketInstance.is_gift ? (
							<div>
								{basketInstance.multi_basket_items?.map((order) => (
									<>
										<Subtitle className="order-summary-items-wrapper text-to-update">{`${order.restaurant.name}`}</Subtitle>
										<Spacer size={1}/>
										<div
											className={`${taxContentLoading ? 'unclickable' : ''} basket-items-wrapper  ${isAlreadyCreatedOrder ? `basket-items-wrapper-${this.getOrderStatusColor(order.status)}` : ''
												} `}
										>
											{showAddItems && (
												<div className="add-items-button-wrapper">
													<IonButton
														onClick={() => this.selectMultiVenueRestaurant(order.restaurant)}
														size="small"
														color="secondary"
														className="add-items-btn link"
													>
														{__('Order more')}
													</IonButton>
												</div>
											)}
											{order.items.map((basketItem, basketItemIndex) => {
												const { quantity, item, instructions } = basketItem;
												let image = item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
												if (image && image.indexOf('http://') !== -1) {
													image = image.replace(/http:\/\//g, 'https://');
												}
												return (
													<div className="box-content" style={{ gap: '30px' }}>
														<div
															className="order-item-image"
															style={
																image && image !== ''
																	? { backgroundImage: `url(${image})` }
																	: {
																		backgroundSize: 'contain',
																		backgroundImage: `url(${order.restaurant?.menu_item_placeholder_image || this.props.clientProfile.logo_image})`,
																	}
															}
														/>
														<div className="item-content-wrapper flex-justify-between flex-row-wrapper">
															<div>
																<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--spacer-0)' }}>
																	<Subtitle className="block ">
																		{`${isAlreadyCreatedOrder ? `${quantity}x ` : ''}${Basket.getProductName(item, profile)}`}</Subtitle>
																	<Subtitle>

																		{basketInstance.formatPrice(basketInstance.calculateItemPrice(basketItem, false))}
																	</Subtitle>
																</div>
																<Spacer size={0} />
																{this.drawSubItemsText(basketItem, basketItemIndex)}
																{basketItem.instructions !== '' && (
																	<>
																		<Spacer size={2} />
																		<SmallText className="block">{`${__('Instructions')}: ${basketItem.instructions}`} </SmallText>
																	</>
																)}
															</div>
															<div className="item-content-actions flex-col-wrapper flex-justify-between  flex-align-center" >
																<div className='flex-col-wrapper flex-align-center' style={{ gap: '30px' }}>
																	<Incrementer
																		onUpdate={(val) => {
																			if (handleOrderItemClick) {
																				handleOrderItemClick(basketItem, basketItemIndex, val, order.restaurant.id);
																			}
																		}}
																		quantity={quantity}
																		step={1}
																		allowNegative={false}
																		minLimit={1}
																	>
																		<StrongText className="bold primary-color">{quantity}</StrongText>
																	</Incrementer>
																	{handleOrderItemClick && (
																		<div className=' remove-btn' onClick={() => { this.setState({ showRemoveItemAlert: true, removeItemAlertFunction: () => handleOrderItemClick(basketItem, basketItemIndex, 0, order.restaurant.id) }) }}>
																			<TrashIcon />
																		</div>
																	)}
																</div>

															</div>
														</div>
													</div>
												);
											})}
										</div>
									</>
								))}
							</div>
						) : (
							<>
								<div className={`basket-items-wrapper ${taxContentLoading ? 'unclickable' : ''}`}>
									<div className="add-items-button-wrapper">
										{showAddItems ? (
											<IonButton size="small" color="secondary" className="add-items-btn link " onClick={() => forwardTo('/order')}>
												{__('Add more items')}
											</IonButton>
										) : null}
									</div>

									{basketInstance.getItems().map((basketItem, basketItemIndex) => {
										const { quantity, item, instructions } = basketItem;
										let image = item.itemRichData && item.itemRichData.squareImageUrl ? item.itemRichData.squareImageUrl : '';
										if (image && image.indexOf('http://') !== -1) {
											image = image.replace(/http:\/\//g, 'https://');
										}
										return (
											<div className="box-content" style={{ gap: '30px' }}>
												<div
													className="order-item-image"
													style={
														image && image !== ''
															? { backgroundImage: `url(${image})` }
															: {
																backgroundSize: 'contain',
																backgroundImage: `url(${Basket.getRestaurant()?.menu_item_placeholder_image ?? this.props.clientProfile.logo_image})`,
															}
													}
												/>
												<div className="item-content-wrapper flex-justify-between flex-row-wrapper">
													<div>
														<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 'var(--spacer-0)' }}>
															<MediumText className="block bold">{`${isAlreadyCreatedOrder ? `${quantity}x ` : ''}${Basket.getProductName(item, profile)}`}</MediumText>
															<MediumText className="block bold">
																{basketInstance.calculateItemPriceByIndex(basketItemIndex, true) > 0 ? basketInstance._calculateItemPriceByIndex(basketItemIndex, true) : null}
															</MediumText>
														</div>

														<Spacer size={0} />

														{this.drawSubItemsText(basketItem, basketItemIndex)}
														{basketItem.instructions && basketItem.instructions !== '' && (
															<>
																<Spacer size={2} />
																<SmallText className="block">{`${__('Instructions')}: ${basketItem.instructions}`} </SmallText>
															</>
														)}
													</div>
													<div className="item-content-actions flex-col-wrapper flex-justify-between  flex-align-center" >
														<div className='flex-col-wrapper flex-align-center' style={{ gap: '30px' }}>
															<Incrementer
																onUpdate={(val) => {
																	if (handleOrderItemClick) {
																		handleOrderItemClick(basketItem, basketItemIndex, val);
																	}
																}}
																quantity={quantity}
																step={1}
																allowNegative={false}
																minLimit={1}

															>
																{quantity}
															</Incrementer>
															{handleOrderItemClick && (
																<div className='remove-btn' onClick={() => { this.setState({ showRemoveItemAlert: true, removeItemAlertFunction: () => handleOrderItemClick(basketItem, basketItemIndex, 0) }) }}>
																	<TrashIcon />
																</div>
															)}
														</div>

													</div>
												</div>
											</div>
										);
									})}
								</div>
							</>
						)}
						<Spacer size={2}/>
					</div>
					<div className='order-content-lines'>
					<IonGrid className="box-content order-content-wrapper paddL">
						<IonRow>
							<IonCol>
								<IonCol class="bold"><MediumText>{__('Items total')}</MediumText></IonCol>
							</IonCol>
							<IonCol className="righted bold"><MediumText>{basketInstance.calculateItemsTotal()}</MediumText></IonCol>
						</IonRow>
					</IonGrid>
					{((basketInstance.service_percentage > 0 || basketInstance.service_percentage === false) &&
						getConfig().general.service_charge_modules?.includes(Basket.order_type) &&
						getConfig().general.hasServiceCharge) &&
						serviceChargeBoxHidden &&

						<IonGrid className="box-content order-content-wrapper paddL">
							<div key="service_charge" className="basket-item-wrapper">
								<IonRow className="basket-item-service-charge-row service-charge-item" onClick={() => this.setState({ serviceChargeBoxModalOpen: true })}>
									<>
										<IonCol className="paddLR grow ">
											<MediumText>
												{__('Service charge')}&nbsp;
												{basketInstance.service_charge_value ? (
													<> {basketInstance.service_percentage !== 0 && basketInstance._getServicePercentage()}</>
												) : (
													<> {basketInstance.service_percentage !== false && basketInstance._getServicePercentage()}</>
												)}

											</MediumText>

										</IonCol>
										<IonCol className="righted paddLR self-center bold">
											<MediumText>
											{basketInstance.getServiceChargeValue() > 0 ? basketInstance.getFormatedServiceChargeValue() : basketInstance.getServiceCharge(true)}
										</MediumText>
										</IonCol>
									</>
								</IonRow>

							</div>
						</IonGrid>
					}
					{basketInstance.process_fee_value > 0 && (
						<IonGrid className="box-content order-content-wrapper paddL">
							<IonRow className="">
								<IonCol className="paddLR grow ">
									<MediumText>
										{Basket.processing_fee_description > 0 ? `${Basket.processing_fee_description}% ` : null}
										{__('Order processing fee')}
									</MediumText>

								</IonCol>
								<IonCol className="righted paddLR self-center bold "><MediumText>{basketInstance.getProcessingFee()}</MediumText></IonCol>
							</IonRow>
						</IonGrid>
					)}
					{basketInstance.discount && (
						<IonGrid className="box-content order-content-wrapper paddL">
							<IonRow>
								<IonCol className="paddLR grow">{basketInstance.discount.title}</IonCol>
								<IonCol className="righted paddLR bold">-{basketInstance.formatPrice(basketInstance.calculateMembershipDiscount())}</IonCol>
							</IonRow>
						</IonGrid>

					)}
					{basketInstance.getTotalTaxBreakdown() > 0 && (
						<>
							<IonGrid className={`box-content tax-lines order-content-wrapper paddL ${taxContentLoading ? 'box-content--loading' : ''}`}>
									<IonRow>
										<IonCol className="paddLR grow"><MediumText>{__('Total taxes')}</MediumText></IonCol>
										<IonCol className="righted paddLR self-center"><MediumText>{basketInstance.formatPrice(basketInstance.getTotalTaxBreakdown(), true)}</MediumText></IonCol>
									</IonRow>

							</IonGrid>
						</>
					)}
					{this.props.serviceChargeBoxAlertOpen && (
						<Modal backdropDismiss={false} className="modal-type-alert" isOpen={this.props.serviceChargeBoxAlertOpen}>
							<Spacer size={5} />
							{this.drawServiceChargeBox(__, service_charge, basketInstance)}
							<Spacer size={5} />
							<div className='alert-button-group'>
								<IonButton
									color="secondary "
									onClick={() => {
										basketInstance.setServicePercentage(0);
										this.finaliseTableOrder();
									}}
								>
									{__('Not this time')}
								</IonButton>
								<IonButton
									expand="block"
									color="primary"
									onClick={() => {
										this.finaliseTableOrder();
									}}
								>
									{__('Done')}
								</IonButton>
							</div>


						</Modal>
					)}


					{basketInstance.service_percentage === 0 &&
						getConfig().general.service_charge_modules?.includes(Basket.order_type) &&
						getConfig().general.hasServiceCharge &&
						serviceChargeBoxHidden &&
						basketInstance.getServiceChargeValue() === null ? (
						<>
							<div key="service_charge" className="basket-item-wrapper">
								<IonButton
									expand="block"
									color='secondary'

									className="link  basket-item-service-charge-row"
									onClick={() => this.setState({ serviceChargeBoxModalOpen: true })}
								>
									{__('Add a service charge')}
								</IonButton>
							</div>
						</>
					) : null}
					{getConfig().general.hasServiceCharge &&
						!basketInstance.service_charge_value &&
						basketInstance.service_charge_value !== 0 &&
						getConfig().general.service_charge_modules?.includes(Basket.order_type) && (
							<>
								{!serviceChargeBoxHidden ? (
									<>{this.drawServiceChargeBox(__, service_charge, basketInstance)}</>
								) : (
									<>
										<Modal
											className="modal-type-alert"
											isOpen={this.state.serviceChargeBoxModalOpen}
											onDidDismiss={() => this.setState({ serviceChargeBoxModalOpen: false })}
										>
											<Spacer size={5} />
											{this.drawServiceChargeBox(__, service_charge, basketInstance)}
											<Spacer size={5} />
											<div className='alert-button-group'>
												<IonButton
													color="secondary "
													onClick={() => {
														basketInstance.setServicePercentage(0);
														this.setState({ serviceChargeBoxModalOpen: false });
													}}
												>
													{__('Not this time')}
												</IonButton>
												<IonButton
													expand="block"
													color="primary"
													onClick={() => {
														this.setState({ serviceChargeBoxModalOpen: false });
													}}
												>
													{__('Done')}
												</IonButton>

											</div>
										</Modal>
									</>
								)}


							</>
						)}
						</div>

					<Modal className="modal-type-alert" isOpen={serviceChargeModalOpen} onDidDismiss={() => this.handleServiceChargeModal(false)}>
						<Subtitle className='block'>{__('Add custom amount')}</Subtitle>
						<Spacer size={5} />
						<IonItem lines="none" className="input-field-wrapper input-field-wrapper-large full-width input-field-wrapper-with-floating-text ">
							<NormalText className='input-field-floating-text label-color'>{Basket.getCurrency().label}</NormalText>
							<IonInput clearInput placeholder='0.00' onInput={(e) => this.setCustomServiceCharge(e.target.value)} type="number" pattern="number" inputmode="number"></IonInput>
						</IonItem>

						{this.state.customAmountErrorVisible && (
							<>
								<SmallText className="danger-color">{__('Value can not be negative')}</SmallText>
							</>
						)}
						<Spacer size={2} />
						<div className='alert-button-group'>
							<IonButton
								expand="block"
								color={'secondary'}
								onClick={() => {
									this.handleServiceChargeModal(false)
								}}
							>
								{__('Cancel')}
							</IonButton>
							<IonButton
								expand="block"
								onClick={() => {
									basketInstance.setServiceCharge(this.state.serviceChargeAmount);
									this.setState({ serviceChargeModalOpen: false });
								}}
								disabled={!this.state.serviceChargeAmount}
							>
								{__('Done')}
							</IonButton>
						</div>

					</Modal>

				</>
				<IonAlert
					isOpen={showRemoveItemAlert}
					onDidDismiss={() => {
						this.setState({ showLastItemAlert: false });
					}}
					header={__('Are you sure you want to remove the selected item?')}
					message={__('')}
					buttons={[

						{
							text: __('Yes'),
							cssClass: 'primary',

							handler: () => this.setState({ showRemoveItemAlert: false }, () => removeItemAlertFunction())
						},
						{
							text: __('No'),
							role: 'cancel',
							cssClass: 'secondary ',
							handler: () => this.setState({ showRemoveItemAlert: false, removeItemAlertFunction: () => null }),
						},
					]}
				/>
			</>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		profile: store.profile.profile,
		isRemoveVoucherModalOpen: store.profile.isRemoveVoucherModalOpen,
		clientProfile: store.common.clientProfile,
		taxContentLoading: store.common.taxContentLoading,
		taxCalculated: store.common.taxCalculated,
		serviceChargeBoxAlertOpen: store.common.serviceChargeBoxAlertOpen,
	};
};

export default connect(mapStateToProps)(withRouter(withTranslation(OrderContent)));
